module.exports = __webpack_public_path__ + "images/category_lp/construction_equipment/store_images/5@2x_bd6f24f2edf0f3021d9faa978eaecf73.png";